import cn from 'classnames';

import Icon from 'components/icon/Icon';
import Link, { LinkTheme } from 'components/link/Link';

import { IPageNavigation } from 'source/NFR.types';

interface PageNavigationProps extends IPageNavigation {
  isLargeArticle?: boolean;
  isFirstPage?: boolean;
}

type IStyleLink = {
  previous: { theme: LinkTheme[] };
  next: { theme: LinkTheme[] };
};

const PageNavigation: React.FC<PageNavigationProps> = ({ previous, next, isLargeArticle, isFirstPage }) => {
  const styleLinkProps: IStyleLink = isLargeArticle
    ? {
        previous: { theme: ['previous', 'navigationLinkNP'] },
        next: { theme: ['next', 'navigationLinkNP'] }
      }
    : {
        previous: { theme: ['previous', 'navigationLink', 'actionLink'] },
        next: { theme: ['next', 'navigationLink', 'actionLink'] }
      };

  return (
    <div
      className={cn('page-navigation', {
        'page-navigation--theme-large-article': isLargeArticle
      })}
    >
      {previous && (
        <Link {...previous} {...styleLinkProps.previous}>
          {isLargeArticle && <Icon name={'arrow-short'} />}
        </Link>
      )}
      {next && (
        <Link
          className={cn({ 'page-navigation--link--is-first-page': isFirstPage })}
          {...next}
          {...styleLinkProps.next}
        >
          {isLargeArticle && <Icon name={'arrow-short'} />}
        </Link>
      )}
    </div>
  );
};

PageNavigation.displayName = 'PageNavigation';

export default PageNavigation;
